export default __webpack_public_path__ + "static/media/canlendar.b37696aa.svg";